function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M283.5 70.9h-56.7V14.2H56.7v56.7H0v141.7h56.7v56.7h170.1v-56.7h56.7V70.9zM85 42.5h113.4v28.3H85V42.5zm113.4 198.4H85v-85h113.4v85zm56.7-56.6h-28.3v-56.7H56.7v56.7H28.3v-85h226.8v85z",
  id: "Print"
})));